import {
  SemItinerarySearchQuery,
  SemItinerarySearchQueryVariables,
} from 'generated/graphql';
import { UseQueryResult } from '@edreamsodigeo/frontend-api-client';
import { useTracking } from '@edreamsodigeo/frontend-core';

export const useSemSearchResponseTrackErrors = (
  queryResult: UseQueryResult<
    SemItinerarySearchQuery,
    SemItinerarySearchQueryVariables
  >
): void => {
  const { trackEvent } = useTracking();
  const hasItineraries =
    (queryResult.data?.semItinerarySearch?.itineraries?.length || 0) > 0;
  if (!queryResult.loading && queryResult.errors) {
    trackEvent({
      action: 'request_errors',
      label: 'error:WNG-024-code:no_itineraries_results',
    });
  } else if (
    queryResult.status !== 'idle' &&
    !queryResult.loading &&
    !queryResult.errors &&
    !hasItineraries
  ) {
    trackEvent({
      action: 'searcher_flights_error',
      label: 'no_results_for_this_search_error',
    });
  }
};
